import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { FaMedium, FaInstagram, FaLinkedinIn } from "react-icons/fa6";
import { useIsMobile } from "../utils/responsive";

export default function Contact() {
  const [hoveredSection, setHoveredSection] = useState(null);
  const [hoveredIcon, setHoveredIcon] = useState(null);

  const handleEmailClick = () => {
    window.location.href = "mailto:hello@kritikagoswamymalik.com";
  };

  const handlePhoneClick = () => {
    window.location.href = "tel:+919810360277";
  };

  const isMobile = useIsMobile();

  const handleSocialClick = (platform) => {
    const links = {
      linkedin:
        "https://www.linkedin.com/in/kritika-goswamy-malik-99605214a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
      instagram:
        "https://www.instagram.com/kritikagm/profilecard/?igsh=eWZkM3cyNXppODVo",
      medium: "https://medium.com/@your-profile",
    };
    window.open(links[platform], "_blank");
  };

  return (
    <Container fluid className="p-0">
      <div className="d-flex justify-content-center">
        {!isMobile && (
          <div
            className="border-bottom-black border-right-black"
            style={{
              width: "5%",
            }}
          ></div>
        )}
        {!isMobile && (
          <div
            className="border-bottom-black border-right-black"
            style={{
              width: "15%",
            }}
          ></div>
        )}
        <div
          className="border-bottom-black"
          style={{
            width: isMobile ? "100%" : "60%",
          }}
        >
          <div
            style={{
              padding: isMobile ? "20px 40px" : "40px 40px",
              borderRight: isMobile ? "none" : "1px solid black",
            }}
          >
            <h3 className="heading-sm m-0 text-center">LET'S COLLABORATE</h3>
          </div>
        </div>
        {!isMobile && (
          <div
            className="border-bottom-black "
            style={{
              width: "15%",
            }}
          ></div>
        )}
        {!isMobile && (
          <div
            className="border-bottom-black border-left-black"
            style={{
              width: "5%",
            }}
          ></div>
        )}
      </div>
      <div
        className="d-flex justify-content-center"
        style={{
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        {!isMobile && (
          <div
            className="border-bottom-black border-right-black"
            style={{
              width: "5%",
            }}
          ></div>
        )}

        <div
          className={`px-3 py-5 border-bottom-black ${
            !isMobile && "border-right-black"
          }`}
          style={{
            width: isMobile ? "100%" : "30%",
            textAlign: "center",
            flex: 1,
            cursor: "pointer",
            transition: "all 0.5s ease",
            backgroundColor:
              hoveredSection === "email"
                ? "rgba(0, 0, 0, 0.02)"
                : "transparent",
          }}
          onMouseEnter={() => setHoveredSection("email")}
          onMouseLeave={() => setHoveredSection(null)}
          onClick={handleEmailClick}
        >
          <h3
            className="heading-sm"
            style={{
              transition: "all 0.5s ease",
              transform:
                hoveredSection === "email"
                  ? "translateY(-5px)"
                  : "translateY(0)",
            }}
          >
            EMAIL
          </h3>
          <p
            className="body-md m-0"
            style={{
              wordBreak: "break-all",
              overflowWrap: "break-word",
              hyphens: "auto",
              transition: "all 0.5s ease",
              transform:
                hoveredSection === "email"
                  ? "translateY(-5px)"
                  : "translateY(0)",
              maxWidth: "100%",
              lineHeight: "1.4",
            }}
          >
            hello@kritikagoswamymalik.com
          </p>
        </div>

        <div
          className={`px-3 py-5 border-bottom-black ${
            !isMobile && "border-right-black"
          }`}
          style={{
            width: isMobile ? "100%" : "30%",
            textAlign: "center",
            flex: 1,
            cursor: "pointer",
            transition: "all 0.5s ease",
            backgroundColor:
              hoveredSection === "mobile"
                ? "rgba(0, 0, 0, 0.02)"
                : "transparent",
          }}
          onMouseEnter={() => setHoveredSection("mobile")}
          onMouseLeave={() => setHoveredSection(null)}
          onClick={handlePhoneClick}
        >
          <h3
            className="heading-sm"
            style={{
              transition: "all 0.5s ease",
              transform:
                hoveredSection === "email"
                  ? "translateY(-5px)"
                  : "translateY(0)",
            }}
          >
            MOBILE
          </h3>
          <p
            className="body-md m-0"
            style={{
              flexWrap: "wrap",
              transition: "all 0.5s ease",
              transform:
                hoveredSection === "mobile"
                  ? "translateY(-5px)"
                  : "translateY(0)",
            }}
          >
            +91&nbsp;99109-40277
          </p>
        </div>

        <div
          className="px-3 py-5 border-bottom-black"
          style={{
            width: isMobile ? "100%" : "30%",
            textAlign: "center",
            flex: 1,
            transition: "all 0.5s ease",
            backgroundColor:
              hoveredSection === "social"
                ? "rgba(0, 0, 0, 0.02)"
                : "transparent",
          }}
          onMouseEnter={() => setHoveredSection("social")}
          onMouseLeave={() => setHoveredSection(null)}
        >
          <h3
            className="heading-sm"
            style={{
              transition: "all 0.5s ease",
              transform:
                hoveredSection === "email"
                  ? "translateY(-5px)"
                  : "translateY(0)",
            }}
          >
            SOCIAL
          </h3>
          <p
            className="body-md m-0"
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "20px",
              wordBreak: "break-all",
              overflowWrap: "break-word",
              hyphens: "auto",
              transition: "all 0.5s ease",
              transform:
                hoveredSection === "social"
                  ? "translateY(-5px)"
                  : "translateY(0)",
              maxWidth: "100%",
              lineHeight: "1.4",
            }}
          >
            <FaLinkedinIn
              style={{
                cursor: "pointer",
                transition: "all 0.5s ease",
                transform:
                  hoveredIcon === "linkedin" ? "scale(1.2)" : "scale(1)",
              }}
              onMouseEnter={() => setHoveredIcon("linkedin")}
              onMouseLeave={() => setHoveredIcon(null)}
              onClick={() => handleSocialClick("linkedin")}
            />
            <FaInstagram
              style={{
                cursor: "pointer",
                transition: "all 0.5s ease",
                transform:
                  hoveredIcon === "instagram" ? "scale(1.2)" : "scale(1)",
              }}
              onMouseEnter={() => setHoveredIcon("instagram")}
              onMouseLeave={() => setHoveredIcon(null)}
              onClick={() => handleSocialClick("instagram")}
            />
            <FaMedium
              style={{
                cursor: "pointer",
                transition: "all 0.5s ease",
                transform: hoveredIcon === "medium" ? "scale(1.2)" : "scale(1)",
              }}
              onMouseEnter={() => setHoveredIcon("medium")}
              onMouseLeave={() => setHoveredIcon(null)}
              onClick={() => handleSocialClick("medium")}
            />
          </p>
        </div>

        {!isMobile && (
          <div
            className="border-bottom-black border-left-black"
            style={{
              width: "5%",
            }}
          ></div>
        )}
      </div>
    </Container>
  );
}
